let installed = false;

/**
 * Chrome on iOS skips an `<img>` on long press only when its computed `-webkit-touch-callout` is
 * `none`; it ignores the `user-select: none` that satisfies Safari. Prepended so game CSS wins.
 */
export function suppressImageTouchCallout(): void {
  if (installed || typeof document === "undefined") {
    return;
  }
  installed = true;
  const style = document.createElement("style");
  style.textContent = "img{-webkit-touch-callout:none}";
  (document.head ?? document.documentElement).prepend(style);
}
